import React from 'react'

/**
 * The atomic status pill / badge primitive. Used for task/goal/session status,
 * priority, and tags. The four `tone` variants map to the semantic palette in
 * `docs/contributor/design-language.md` §2.3.
 */
export function Pill({ tone = 'neutral', as: Tag = 'span', className = '', children, ...rest }) {
  const classes = ['pill', `pill--${tone}`, className].filter(Boolean).join(' ')
  return (
    <Tag className={classes} data-tone={tone} {...rest}>
      {children}
    </Tag>
  )
}
